// 상태 텍스트 변환
function getStateText(state) {
  const stateMap = {
    0: '임시저장',
    1: '결재 대기',
    2: '결재중',
    3: '결재완료',
    4: '반려',
    7: '관리자취소',
  };
  return stateMap[state] || '결재중';
}

// 휴가신청 목록 (휴가결재 페이지와 동일한 너비 적용)
export const vacationRequestColumns = [
  {
    key: 'date',
    label: '신청일자',
    width: '141px',
    sortable: true,
    render: (value) => value,
  },
  {
    key: 'state',
    label: '문서상태',
    width: '128px',
    sortable: true,
    render: function (value) {
      return getStateText(value);
    },
  },
  {
    key: 'writerInfo',
    label: '기안자',
    width: '137px',
    sortable: false,
    render: function (value, item) {
      return item.writerInfo?.name || '-';
    },
  },
  {
    key: 'signerInfo',
    label: '결재자',
    width: '137px',
    sortable: false,
    render: function (value, item) {
      return item.signerInfo?.name || '-';
    },
  },
  {
    key: 'vacation_type',
    label: '휴가구분',
    width: '198px',
    sortable: false,
    render: function (value, item) {
      const type = item.vacation_type?.name || '-';
      const cc = item.cc_type?.name;
      return cc ? `${type}-${cc}` : type;
    },
  },
  {
    key: 'start_date',
    label: '시작일자',
    width: '160px',
    sortable: true,
    render: (value) => value,
  },
  {
    key: 'end_date',
    label: '종료일자',
    width: '160px',
    sortable: true,
    render: (value) => value,
  },
  {
    key: 'period',
    label: '휴가기간',
    width: '101px',
    sortable: true,
  },
  {
    key: 'reason',
    label: '신청내역',
    width: '165px',
    sortable: false,
    //신청내역의 내용이 너무 길것을 대비하여 말줄임표 추가
    render: (value) => {
      if (!value) return '-';

      const MAX_LENGTH = 14;
      const isEllipsis = value.length > MAX_LENGTH;
      const displayText = isEllipsis ? `${value.slice(0, MAX_LENGTH)}…` : value;

      return <span title={isEllipsis ? value : undefined}>{displayText}</span>;
    },
  },
];
